// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-cs1 {
  background-color: #d68915;
  border-radius: 19px;
}

.w-100 {
  width: 100%;
}

.float-right {
  float: right;
}`, "",{"version":3,"sources":["webpack://./src/app/ist/ist-application-ext/ist-all-requests/fund-request-modal/fund-request-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EAA2B,mBAAA;AAE7B;;AACA;EACE,WAAA;AAEF;;AACA;EACE,YAAA;AAEF","sourcesContent":[".p-cs1{\r\n  background-color: #d68915; border-radius: 19px;\r\n}\r\n\r\n.w-100{\r\n  width: 100%;\r\n}\r\n\r\n.float-right{\r\n  float:right;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
